var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRatingsi = function SvgRatingsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ratings_i_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ratings_i_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11.987 3c4.965 0 8.998 4.033 8.998 9s-4.033 9-8.998 9-8.998-4.033-8.998-9 4.033-9 8.998-9m0 1.37A7.64 7.64 0 0 0 4.354 12a7.64 7.64 0 0 0 7.632 7.631 7.631 7.631 0 1 0 .001-15.261M15.918 12a.684.684 0 1 1 1.366 0 5.3 5.3 0 0 1-5.297 5.299A5.3 5.3 0 0 1 6.689 12a.684.684 0 1 1 1.366 0c0 2.169 1.763 3.93 3.932 3.93s3.932-1.761 3.932-3.93z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRatingsi);
export default ForwardRef;